import {Component, Input} from '@angular/core'

@Component({
  selector: 'app-page-title-with-back-button',
  templateUrl: './page-title-with-back-button.component.html',
  styleUrl: './page-title-with-back-button.component.scss',
})
export class PageTitleWithBackButtonComponent {
  @Input() title: string = ''
  @Input() description: string = ''

  goBack(): void {
    window.history.back()
  }
}
